import { yup } from '@framework/validation';
import { CiComputedNumberGear } from '../../../../../ui/icons-custom/IconsCustom';
import { Datatype } from '../../../../expressions/datatype/Datatype';
import { getDynamicWidgetReference } from '../../../../expressions/references/builder/getDynamicWidgetReference';
import { tran } from '../../../../translations/schema/TranslationSchema';
import { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { createCommonFormSchema } from '../../inputs/common/createCommonFormSchema';
import { CommonComputedWidgetConfigComponent } from '../CommonComputedWidgetConfigComponent';
import { CommonComputedWidgetPreview } from '../CommonComputedWidgetPreview';
import { IComputedNumberWidget } from '../IComputedWidget';
import { ComputedNumberConfigSchema } from './ComputedNumberConfigSchema';
import { ComputedNumberWidgetComponent } from './ComputedNumberWidgetComponent';
import { setComputedNumberTransform } from './setComputedNumberTransform';

export const ComputedNumberWidgetType: IWidgetType<IComputedNumberWidget> = {
  type: WidgetType.ComputedNumber,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Computed,
  hasValue: true,
  getReference: getDynamicWidgetReference(Datatype.Number),
  name: 'Numero Calcolato',
  icon: <CiComputedNumberGear />,
  rules: [],
  formComponent: ComputedNumberWidgetComponent,
  createFormSchema: ({ widget, parentScope }) => {
    return createCommonFormSchema(
      setComputedNumberTransform(
        widget,
        parentScope,
        yup.number().notRequired(),
      ),
      widget,
    );
  },
  configComponent: CommonComputedWidgetConfigComponent,
  configValidator: ComputedNumberConfigSchema,
  previewComponent: CommonComputedWidgetPreview,
  translationSchema: tran.widget({
    label: tran.rte(),
  }),
  alwaysEnabled: true,
};
